import { render, staticRenderFns } from "./NewsVideo.vue?vue&type=template&id=45f3314c&scoped=true&"
import script from "./NewsVideo.vue?vue&type=script&lang=ts&"
export * from "./NewsVideo.vue?vue&type=script&lang=ts&"
import style0 from "./NewsVideo.vue?vue&type=style&index=0&id=45f3314c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3314c",
  null
  
)

export default component.exports